module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-right-orange-b8294513616b001bdda3bff40f62bdfb.svg";